import React, { useEffect, useState } from 'react';
import { apiFetch } from '../lib/apiFetch';
import { ReplenishSugerencia, ApiResponse } from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const PRIORIDAD_ICON: Record<string, string> = { alta: '🔴', media: '🟡', baja: '🟢' };

interface Props {
    onClose?: () => void;
}

export const ReplenishSuggestionPanel: React.FC<Props> = ({ onClose }) => {
    const [data, setData] = useState<ReplenishSugerencia | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await apiFetch(`${API_BASE}/tareas/replenish-suggestion?count=5`);
            const json: ApiResponse<ReplenishSugerencia> = await res.json();
            if (json.success && json.data) setData(json.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(); }, []);

    return (
        <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm">
            <div className="flex items-center justify-between mb-3">
                <div>
                    <h3 className="text-base font-semibold text-slate-800">📥 Sugerencias de Reposición</h3>
                    <p className="text-xs text-slate-500">
                        Candidatos del Backlog para mover a Por Hacer cuando hay cupo.
                    </p>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={fetchData}
                        disabled={loading}
                        className="px-3 py-1 text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 rounded"
                    >
                        {loading ? '⟳' : '↻'} Refrescar
                    </button>
                    {onClose && (
                        <button onClick={onClose} className="px-3 py-1 text-xs bg-slate-800 text-white rounded hover:bg-slate-700">
                            Cerrar
                        </button>
                    )}
                </div>
            </div>

            {!data || data.items.length === 0 ? (
                <div className="text-sm text-slate-400 italic py-4 text-center">
                    {loading ? 'Cargando...' : 'Backlog vacío'}
                </div>
            ) : (
                <div className="space-y-2">
                    {data.items.map(item => (
                        <div
                            key={item.id}
                            className="flex items-start gap-3 p-3 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
                        >
                            <div className="w-1 self-stretch rounded-full" style={{ backgroundColor: item.cliente_color }} />
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="text-xs font-mono text-slate-500">#{item.id}</span>
                                    <span className="text-xs">{PRIORIDAD_ICON[item.prioridad]}</span>
                                    {item.clase_servicio === 'fecha_fija' && (
                                        <span className="text-[10px] px-1.5 py-0.5 bg-blue-100 text-blue-800 rounded">📌 FECHA FIJA</span>
                                    )}
                                    {item.clase_servicio === 'expedito' && (
                                        <span className="text-[10px] px-1.5 py-0.5 bg-amber-100 text-amber-800 rounded">⚡ EXPEDITO</span>
                                    )}
                                    <span className="text-[10px] px-1.5 py-0.5 bg-slate-100 text-slate-600 rounded">{item.dias_en_backlog}d en backlog</span>
                                </div>
                                <div className="text-sm font-medium text-slate-800 mt-1">{item.titulo}</div>
                                <div className="text-xs text-slate-500 mt-0.5">{item.empresa}</div>
                                <div className="text-xs text-slate-400 mt-1 italic">{item.razon}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
